import imageOne from '@/assets/images/cities/ottawa1.jpg'
import imageTwo from '@/assets/images/cities/ottawa2.jpg'
import imageThree from '@/assets/images/cities/ottawa3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Ottawa',
  writeup: '',
  website: 'MyOttawaNotaryPublic.com',
  url: 'https://www.myottawanotarypublic.com/',
  notaries: [
    {
      name: 'Nepean',
      open: true,
      phone: '(613) 317-2499',
      hours: {
        monday: '',
        tuesday: '12:30PM to 4:30PM',
        wednesday: '12:30PM to 4:30PM',
        thursday: '',
        friday: '12:30PM to 4:30PM',
        saturday: '',
        sunday: ''
      },
      address: 'Fallowfield Road Location',
      notes: ''
    },
    {
      name: 'Ottawa South',
      open: true,
      phone: '(613) 317-2499',
      hours: {
        monday: '9:30AM to 5:00PM',
        tuesday: '9:30AM to 5:00PM',
        wednesday: '9:30AM to 5:00PM',
        thursday: '9:30AM to 5:00PM',
        friday: '9:30AM to 5:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: 'Bank Street Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/ottawa.js